import{useRef as r,useEffect as t}from"react";function n(){var n=r(!0);return t(function(){n.current=!1},[]),n.current}export{n as useInitialRender};
//# sourceMappingURL=index.m.js.map
